export default __webpack_public_path__ + "static/media/ic_logo.8f63c4a9.png";